{
  "instances": {
    "flyway": {
      "label": "Flyway",
      "type": "Gerð",
      "checksum": "Checksum",
      "version": "Útgafa",
      "description": "Lýsing",
      "script": "Forskrift",
      "state": "Staða",
      "installed_by": " Sett upp af",
      "installed_on": "Sett upp á",
      "installed_rank": "Uppsett staða",
      "execution_time": "Tími framkvæmdarinnar"
    }
  }
}
